import { compareValues } from "@sscs/utils";
import { MyInsightsSearch, QuickInsightsSearch } from "../types";

export const sortMySearches = (
  searches: MyInsightsSearch[],
): MyInsightsSearch[] => {
  return searches.toSorted((first, second) =>
    compareValues(first.name, second.name, false),
  );
};

export const sortQuickSearches = (
  searches: QuickInsightsSearch[],
): QuickInsightsSearch[] => {
  return searches.toSorted((first, second) =>
    compareValues(first.id, second.id, false),
  );
};
